export default "__VITE_ASSET__HRZmRFas__"